import { render, staticRenderFns } from "./CardActions.vue?vue&type=template&id=6633bafc&scoped=true&"
import script from "./CardActions.vue?vue&type=script&lang=js&"
export * from "./CardActions.vue?vue&type=script&lang=js&"
import style0 from "./CardActions.vue?vue&type=style&index=0&id=6633bafc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6633bafc",
  null
  
)

export default component.exports